import { render, staticRenderFns } from "./ErrorsList.vue?vue&type=template&id=d9e47c5e"
import script from "./ErrorsList.vue?vue&type=script&lang=js"
export * from "./ErrorsList.vue?vue&type=script&lang=js"
import style0 from "./ErrorsList.vue?vue&type=style&index=0&id=d9e47c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports